import { FlexProps } from 'UIKit/Box/types'
import Text from 'UIKit/Text'
import { RouteConfig } from 'config/constants/route'
import { useCloseAllModal } from 'hooks/useModal'
import { useRouter } from 'hooks/useRouter'
import { RowBetween, RowMiddle } from 'layout/Components/Row'
import { Trans } from 'react-i18next'
import styled from 'styled-components'
import { Icons } from 'svgs'
import theme from 'theme'

const TwoFactorWarning: React.FC<FlexProps> = ({ ...props }) => {
  const router = useRouter()
  const closeModal = useCloseAllModal()

  const handleRedirectToSettingSecurity = () => {
    router.push(RouteConfig.SettingSecurity)
    closeModal()
  }

  return (
    <StyledTab onClick={handleRedirectToSettingSecurity} {...props}>
      <RowMiddle gap="8px">
        <Icons.ShieldIcon />
        <Text fontWeight={400} color="textAlt699">
          <Trans>2FA: Off</Trans>
        </Text>
      </RowMiddle>
      <Icons.ChevronRightIcon fill={theme.colors.textAlt699} height="14px" />
    </StyledTab>
  )
}

const StyledTab = styled(RowBetween)`
  flex: 0;
  padding: 8px;
  gap: 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.2s;
  position: relative;

  svg {
    color: ${({ theme }) => theme.colors.textAlt8};
    transition: 0.2s;
  }

  ${Text} {
    color: ${({ theme }) => theme.colors.textAlt699};
    transition: 0.2s;
  }

  &:hover {
    svg {
      color: ${({ theme }) => theme.colors.text};
    }

    ${Text} {
      color: ${({ theme }) => theme.colors.text};
    }
  }
`

export default TwoFactorWarning
